var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"social"},[_c('a',{attrs:{"target":"_blank","href":"https://www.linkedin.com/in/chunhakrai-buncherdjaruwong-299a461a8/"}},[_c('span',{staticClass:"fa fa-linkedin-square"})]),_c('a',{attrs:{"target":"_blank","href":"https://twitter.com/"}},[_c('span',{staticClass:"fa fa-envelope"})])])
}]

export { render, staticRenderFns }